import {
  SET_BASE_PLATE_FACTOR_A,
  SET_STAND_OFF_DIMENSION,
  SET_STAND_OFF_RESTRAINT_LEVEL,
  SET_STAND_OFF_MORTAR_STRENGTH,
  SET_SLOTTED_HOLES_ACTIVE_BTN,
  SET_ORIENTATION_ACTIVE_BTN,
  SET_GRADE_STEEL_BAR,
  SET_BEAM_OFFSET,
  SET_BASEPLATE_OPTIONS,
  SET_PEDESTAL_DIMENSIONS,
  SET_SAFETY_BARRIER_DIMENSIONS,
  SET_STAIRS_DIMENSIONS,
  SET_WALL_DIMENSIONS,
  RESET_DIMENSION_STATE,
  SET_DIMENSIONS_CONCRETE_MEMBER,
  SET_DIMENSION_STATE,
  SET_WOOD_BRACKET_OPTIONS,
  SET_NAILS_CONFIGURATION,
  SET_ANCHORS_CONFIGURATION
} from './actions';
import { APP_TYPES, BRAND } from '@config';
import { mergeDeep } from '@services/helper.service';
import { 
  SET_SCREW_PADDING_D, 
  SET_SCREW_PADDING_S, 
  SET_SCREW_SHIFT_C, 
  SET_SCREW_SHIFT_C1,
  TOGGLE_SCREW_MAX_LENGTH,
  SET_SCREW_MAX_LENGTH,
  SET_SCREW_N_COUNT,
  SET_SCREW_COORDINATES,
  SET_CUSTOM_COORDINATES
} from '@reducers/options/screw/actions';
import { brandList, countryList } from './../../../app.values';

export const imperialState = {
  [APP_TYPES.GENERAL_CALCULATION]: {
    basePlate: {
      lx: 304.8,
      ly: 304.8,

      tfix: 15.24,

      spacing: {
        s1: 203.2,
        s2: 203.2,
        d: 203.2,
        s: 203.2,
      }
    }
  },
  [APP_TYPES.BRACKET_ATTACHMENT]: {
    basePlate: {
      lx: 304.8,
      ly: 304.8,

      tfix: 15.24,

      spacing: {
        s1: 203.2,
        s2: 203.2,
      }
    }
  }
};

export const metricState = {
  [APP_TYPES.GENERAL_CALCULATION]: {
    basePlate: {
      lx: 250,
      ly: 250,

      tfix: 8,

      spacing: {
        s1: 120,
        s2: 120,
        d: 120,
        s: 120,
      }
    }
  },
  [APP_TYPES.BRACKET_ATTACHMENT]: {
    basePlate: {
      lx: 250,
      ly: 250,

      tfix: 8,

      spacing: {
        s1: 120,
        s2: 120,
      }
    }
  }
};

export const initState = {
  [APP_TYPES.GENERAL_CALCULATION]: {
    basePlate: {
      lx: metricState[APP_TYPES.GENERAL_CALCULATION].basePlate.lx,
      ly: metricState[APP_TYPES.GENERAL_CALCULATION].basePlate.ly,
      dpp: null,
      dpl: null,
      lyh: null,

      orientationActiveBtn: '1',

      tfix: metricState[APP_TYPES.GENERAL_CALCULATION].basePlate.tfix,

      spacing: {
        s1: metricState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.s1,
        s2: metricState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.s2,
        d: metricState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.d,
        s: metricState[APP_TYPES.GENERAL_CALCULATION].basePlate.spacing.s,

        n: null, // Screw count n
        m: null, // Screw count m

        specifyCoordinates: false,

        screwCoordinates: []
      },

      edgeDistance: {
        c1x: null,
        c1y: null,
        c2x: null,
        c2y: null
      }
    },
    slottedHoles: {
      activeBtn: '1'
    },
    axisPosition: {
      ex: 0,
      ey: 0
    },
    basePlateFactor: {
      factor_a: '1'
    },
    standOff: {
      standOffDimensionL: 50,
      restraintLevel: 2,
      mortarStrength: true
    }
  },
  [APP_TYPES.BRACKET_ATTACHMENT]: {
    basePlate: {
      lx: metricState[APP_TYPES.BRACKET_ATTACHMENT].basePlate.lx,
      ly: metricState[APP_TYPES.BRACKET_ATTACHMENT].basePlate.ly,

      tfix: metricState[APP_TYPES.BRACKET_ATTACHMENT].basePlate.tfix,

      spacing: {
        s1: metricState[APP_TYPES.BRACKET_ATTACHMENT].basePlate.spacing.s1,
        s2: metricState[APP_TYPES.BRACKET_ATTACHMENT].basePlate.spacing.s2,

        n: null, // Screw count n
        m: null, // Screw count m

        specifyCoordinates: false,

        screwCoordinates: []
      },

      edgeDistance: {
        c1x: null,
        c1y: null,
        c2x: null,
        c2y: null
      }
    },
    axisPosition: {
      ex: 0,
      ey: 0
    },
    basePlateFactor: {
      factor_a: '1'
    }
  },
  [APP_TYPES.SAFETY_BARRIER]: {
    safetyBarrierDimensions: {
      hgc: 1000,
      dpot: 1000,
      claddingPercentage:100
    },
    pedestalDimensions: {
      h1: 250,
      h2: 200,
      w: 200,
      href: 100
    },
    stairsDimensions: {
      hst: 150,
      lst: 250,
      tst: 200,
    },
    wallDimensions: {
      w: 300
    },
    basePlate: {
      lx: 150,
      ly: 150,

      tfix: 8,

      dpp: 25,
      dpl: 50, 
      lyh: 150,

      spacing: {
        s1: 100, // buttonsOptions[0].subtypes[0].plate[1].config.screw.padding.s1, - circular reference
        s2: 100, // buttonsOptions[0].subtypes[0].plate[1].config.screw.padding.s2,
        dy: 75, // buttonsOptions[0].subtypes[0].plate[1].config.screw.padding.dy,
        d: 100, // buttonsOptions[0].subtypes[0].plate[1].config.screw.padding.diameter
      },

      edgeDistance: {
        c1x: null,
        c1y: 100
      }
    },
    axisPosition: {
      ex: 0,
      ey: 0
    },
    basePlateFactor: {
      factor_a: '1'
    }
  },
  [APP_TYPES.REBAR_REINFORCEMENT]: {
    reinforcementParameters: {
      gradeSteelBar: 'Fe E500',

      maxInstallationLength: {
        active: false,
        value: 0
      },

      layers: 2,
      s: 200,
      c1: 100,
      d: 100,
      c: 100
    },
    dimensionsConcreteMember: {
      wa: 1000,
      wb: 1000,
      ha: 1000,
      hb: 300,
      la: 500,
      lb: 500
    }
  },
  [APP_TYPES.WOOD_CONNECTION]: {
    basePlate: {
      edgeDistance: {
        c1x: null,
        c1y: null,
        c2x: null,
        c2y: null
      }
    },
    bracket: {
      dimensions: {
        a: 290, //vertical plate ly
        b: 50, //horizontal plate ly
        c: 40, //vertical plate lx
        d: 40 //horizontal plate lx
      },
      thickness: {
        tfixA: 3,
        tfixB: 8
      }
    },
    nailsConfiguration: {
      diameter: 4,
      n: 3,
      p: 7,
      spacings: {
        sc: 15,
        s1: 40,
        s2: 40,
        s3: 40,
        s4: 40,
        s5: 40,
        c1Top: 35,
        c2Top: 15,
        c3Top: 35,
        c4Top: 15,
        c5Top: 35
      }
    },
    anchorsConfiguration: {
      diameter: 10,
      n: 1,
      isCoordinatesEnabled: false,
      coordinates: [
        { id: 1, x: 0, y: 0 },
      ]
    }
  }
};

const dimension = (state = initState, action) => {
  switch (action.type) {
    case SET_BASE_PLATE_FACTOR_A: {
      return mergeDeep({}, state, {
        [action.appType]: {
          basePlateFactor: {
            factor_a: action.value
          }
        }
      });
    }
    case SET_STAND_OFF_DIMENSION: {
      return mergeDeep({}, state, {
        [action.appType]: {
          standOff: {
            standOffDimensionL: action.value
          }
        }
      });
    }
    case SET_STAND_OFF_RESTRAINT_LEVEL: {
      return mergeDeep({}, state, {
        [action.appType]: {
          standOff: {
            restraintLevel: action.value
          }
        }
      });
    }
    case SET_STAND_OFF_MORTAR_STRENGTH: {
      return mergeDeep({}, state, {
        [action.appType]: {
          standOff: {
            mortarStrength: action.value
          }
        }
      });
    }
    case SET_BEAM_OFFSET: {
      return mergeDeep({}, state, {
        [action.appType]: {
          axisPosition: {
            ex: action.ex,
            ey: action.ey
          }
        }
      });
    }

    case SET_SLOTTED_HOLES_ACTIVE_BTN: {
      state[APP_TYPES.GENERAL_CALCULATION].slottedHoles.activeBtn = action.id;

      return mergeDeep({}, state);
    }

    case SET_ORIENTATION_ACTIVE_BTN: {
      state[APP_TYPES.GENERAL_CALCULATION].basePlate.orientationActiveBtn = action.id;

      return mergeDeep({}, state);
    }

    case SET_GRADE_STEEL_BAR: {
      state[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.gradeSteelBar = action.value;

      return mergeDeep({}, state);
    }
    case TOGGLE_SCREW_MAX_LENGTH: {
      state[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.maxInstallationLength.active = action.value;

      return mergeDeep({}, state);
    }
    case SET_SCREW_MAX_LENGTH: {
      state[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.maxInstallationLength.value = action.value;

      return mergeDeep({}, state);
    }
    case SET_SCREW_N_COUNT: {
      state[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.layers = action.value;

      return mergeDeep({}, state);
    }
    case SET_SCREW_PADDING_D: {
      state[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.d = action.value;

      return mergeDeep({}, state);
    }
    case SET_SCREW_PADDING_S: {
      state[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.s = action.value;

      return mergeDeep({}, state);
    }
    case SET_SCREW_SHIFT_C: {
      state[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.c = action.value;

      return mergeDeep({}, state);
    }
    case SET_SCREW_SHIFT_C1: {
      state[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.c1 = action.value;

      return mergeDeep({}, state);
    }

    case SET_SCREW_COORDINATES: {
      return mergeDeep({}, state, {
        [action.appType]: {
          basePlate: {
            spacing: {
              screwCoordinates: action.coordinates
            }
          }
        }
      });
    }

    case SET_CUSTOM_COORDINATES: {
      return mergeDeep({}, state, {
        [action.appType]: {
          basePlate: {
            spacing: {
              specifyCoordinates: action.isActive
            }
          }
        }
      });
    }

    case SET_BASEPLATE_OPTIONS: {
      return mergeDeep({}, state, {
        [action.appType]: {
          basePlate: action.options
        }
      });
    }
    case SET_SAFETY_BARRIER_DIMENSIONS: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          safetyBarrierDimensions: action.options
        }
      });
    }
    case SET_PEDESTAL_DIMENSIONS: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          pedestalDimensions: action.options
        }
      });
    }
    case SET_STAIRS_DIMENSIONS: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          stairsDimensions: action.options
        }
      });
    }
    case SET_WALL_DIMENSIONS: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          wallDimensions: action.options
        }
      });
    }

    case SET_DIMENSIONS_CONCRETE_MEMBER: {
      return mergeDeep({}, state, {
        [APP_TYPES.REBAR_REINFORCEMENT]: {
          dimensionsConcreteMember: action.options
        }
      });
    }

    case RESET_DIMENSION_STATE: {
      var retState = mergeDeep({}, 
        state, 
        {
          [action.appType]: initState[action.appType]
        }
      );
      
      if (metricState[action.appType]){
        if (BRAND === brandList.Redhead && Number(action.country) !== countryList.Canada)
          retState = mergeDeep({}, retState, { [action.appType]: imperialState[action.appType] });
        else
          retState = mergeDeep({}, retState, { [action.appType]: metricState[action.appType] });
      }
      
      return retState;
    }
    case SET_DIMENSION_STATE: {
        return action.state;
    }
    case SET_WOOD_BRACKET_OPTIONS:
      return mergeDeep({}, state, {
        [APP_TYPES.WOOD_CONNECTION]: {
          bracket: action.options
        }
      });
    
    case SET_NAILS_CONFIGURATION:
      return mergeDeep({}, state, {
        [APP_TYPES.WOOD_CONNECTION]: {
          nailsConfiguration: action.options
        }
      });
      
    case SET_ANCHORS_CONFIGURATION:
      return mergeDeep({}, state, {
        [APP_TYPES.WOOD_CONNECTION]: {
          anchorsConfiguration: action.options
        }
      });
    default: {
      return state;
    }
  }
};

export default dimension;



// WEBPACK FOOTER //
// ./src/reducers/selectors/dimension/index.js